package app.nestbridge.app.ui

import com.karawek.core.auth.screen.AuthenticationScreen
import com.karawek.core.auth.screen.AuthenticationState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class AuthenticationUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is AuthenticationScreen -> ui<AuthenticationState> { state, modifier -> AuthenticationUi(state = state, modifier = modifier) }
    else -> null
  }
}
